import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=4c190ee6&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=ts&"
export * from "./Sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=4c190ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c190ee6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c190ee6')) {
      api.createRecord('4c190ee6', component.options)
    } else {
      api.reload('4c190ee6', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=4c190ee6&scoped=true&", function () {
      api.rerender('4c190ee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Staff/Sidebar.vue"
export default component.exports